/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Wed Jul 24 2024
 **/

import styled from "@emotion/styled";

import { Row } from "@/frameworks/designStuff/components";

interface AvatarSizeType {
	kind: "large" | "small";
	callType?: "calling" | "before_call" | "none" | "no_response";
}

export const MicIconWrapper = styled(Row)<AvatarSizeType>`
	background-color: ${({ theme }) => theme.colors.error_40_100};
	position: absolute;
	right: -3px;
	bottom: 0;
	width: 28px;
	height: 28px;
	border-radius: 50%;
	z-index: 1;
	right: ${({ kind, callType }) => (kind === "large" ? -3 : kind === "small" && callType === "none" ? -10 : -16)}px;
	bottom: ${({ kind, callType }) => (kind === "large" ? 0 : kind === "small" && callType === "none" ? 3 : -5)}px;
`;

export const CallIconWrapper = styled(Row)<AvatarSizeType>`
	width: ${({ kind }) => (kind === "large" ? 38 : 28)}px;
	height: ${({ kind }) => (kind === "large" ? 38 : 28)}px;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	background-color: ${({ theme, callType }) =>
		callType === "calling"
			? theme.colors.success_80_100
			: callType === "no_response"
				? theme.colors.error_40_100
				: ""};
	border-radius: 100%;
	z-index: 2;
`;

export const CloseButtonWrapper = styled(Row)<AvatarSizeType>`
	background-color: ${({ theme }) => theme.colors.error_40_100};
	position: absolute;
	right: ${({ kind }) => (kind === "large" ? -8 : -16)}px;
	top: ${({ kind }) => (kind === "large" ? -5 : -6)}px;
	width: 28px;
	height: 28px;
	border-radius: 50%;
	z-index: 2;
`;
